
/**
 * Definition os Session Message Status
 */
class SessionStatus {
    status = {
        SUCCESS: 1,
        INFO: 2,
        ERROR: 3,
        WARNING: 4
    }
}

module.exports = new SessionStatus();